
import React from 'react';

const pipelineSteps = [
  { key: "pending", label: "REÇUE" },
  { key: "preparing", label: "EN PRÉPARATION" },
  { key: "ready", label: "PRÊTE" },
  { key: "out_for_delivery", label: "EXPÉDIÉ" },
  { key: "delivered", label: "LIVRÉ" }
];

const OrderPipeline = ({ order, onAdvance, lifecycleKey }) => {
  const isCancelled = lifecycleKey === 'cancelled';
  
  if (isCancelled) {
    return (
      <div className="order-pipeline">
        <div className="order-pipeline-step cancelled active">ANNULÉE</div>
      </div>
    );
  }

  // Adjust labels based on mode
  const steps = [...pipelineSteps];
  if (order.orderMode === 'takeaway') {
    steps[3].label = "REMIS";
  }

  const activeIndex = steps.findIndex(s => s.key === lifecycleKey);
  const currentIdx = activeIndex === -1 && lifecycleKey === 'paid' ? 0 : activeIndex; // 'paid' treats 'pending' as active or next to preparing
  
  return (
    <div className="order-pipeline">
      {steps.map((step, idx) => {
        let statusClass = "";
        // If current
        if (lifecycleKey === step.key || (lifecycleKey === 'paid' && step.key === 'pending')) {
           statusClass = "active " + (step.key === 'delivered' ? 'delivered-step' : 'current-step');
        } else if (idx < currentIdx || (lifecycleKey === 'paid' && idx === 0)) {
           statusClass = "completed";
        }
        
        return (
          <div key={step.key} className={`order-pipeline-step ${statusClass}`} onClick={() => onAdvance(step.key)}>
             {step.label}
             {(statusClass.includes('active') || statusClass.includes('completed')) && step.key === 'pending' && (
                <div className="step-date">{(order.date || "").slice(0,10)}</div>
             )}
          </div>
        );
      })}
    </div>
  );
};

export default OrderPipeline;
